import { Language, Level } from "types";

type LanguageData = {
  studyLanguageId?: string;
};

export const getLanguageData = (): LanguageData => {
  const languageData = localStorage.getItem("language");
  if (languageData) {
    return JSON.parse(languageData);
  }

  return { studyLanguageId: "1" };
};

export const storeLanguage = (languageData: LanguageData) => {
  const oldLanguageData = getLanguageData();
  localStorage.setItem(
    "language",
    JSON.stringify({
      ...oldLanguageData,
      ...languageData,
    })
  );
};

export const getLevelId = (
  languageId: string | number,
  languageList: Language[],
  currentLevelId: string | number
) => {
  const activeLanguage = languageList?.find(
    (language: Language) => language.id === languageId
  );

  const isContainUserLevel = activeLanguage?.levels.find((level: Level) => {
    return level.id === currentLevelId;
  });
  return isContainUserLevel
    ? currentLevelId
    : activeLanguage?.levels?.find((level) => level.active)?.id;
};

export const setIsChineseLanguage = (
  languageId: string | number,
  languageList: Language[]
): boolean => {
  const activeLanguage = languageList.find(
    (language: Language) => language.id === languageId
  );

  const isChinese = activeLanguage?.languageCategory?.name
    .toUpperCase()
    .includes("CHINA");
  return isChinese as boolean;
};

export const mapLanguagesByLevelId = (
  languages?: Language[]
): Record<string, Language> => {
  return (languages || []).reduce((languageObject, language) => {
    const updatedLanguageObject = { ...languageObject };
    language.levels.forEach((level) => {
      updatedLanguageObject[level.id] = language;
    });
    return updatedLanguageObject;
  }, {} as Record<string, Language>);
};

export const filterActiveLevelsAndCurrentUserLevel = (
  currentLevelId: string | number,
  levels: Level[] = []
) => {
  const filteredLevels =
    levels?.filter((level: Level) => {
      return level.active || level.id === currentLevelId;
    }) || [];
  return filteredLevels;
};
